$(function(){
  $('.js-load-more').on('click', function(){
    PaginationLoadNext();
  });
  
  $(window).on('resize scroll', function() {
    if ($('.js-load-more').length > 0) {
      if ($('.js-load-more').isInViewport()) {
        if (!$('.js-load-more').is('.loading')) {
          $('.js-load-more').addClass('loading');
          PaginationLoadNext();
        }
      }
    }
  });
  
  function PaginationLoadNext() {
    var $this = $('.js-load-more'), totalPages = parseInt($('[data-all-pages]').val()), currentPage = parseInt($('[data-this-page]').val()), datacollurl = $('[data-coll-url]').val();
    $this.attr('disabled', true);
    $this.find('[load-more-text]').addClass('hide');
    $this.find('[loader]').removeClass('hide');
    var nextUrl = $('[data-next-link]').val();
    var current_page_new = currentPage + 1;
    var next_coll = currentPage + 2;
    
    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function(responseHTML){
        $('[data-next-link]').val(datacollurl + "?page="+next_coll);
        $('[data-this-page]').val(current_page_new);
        $('.product-list__inner').append($(responseHTML).find('.product-list__inner').html());
        loopSearchProductsByType();
      },
      complete: function() {
        if(current_page_new < totalPages) {
          $this.removeClass('loading');
          $this.attr('disabled', false);
          $this.find('[load-more-text]').removeClass('hide');
          $this.find('[loader]').addClass('hide');
        }
        if(current_page_new >= totalPages) {
          $this.remove();
        }
      }
    });
  }
});

$.fn.isInViewport = function() {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();
  
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();
  
  return elementBottom > viewportTop && elementTop < viewportBottom;
};

// SnapCache
var snapbackCache = SnapbackCache({
  bodySelector: "#AjaxinateLoop",
});

var SnapbackCache=function(e){var e=e||{},t={set:function(e,t,n){var o=sessionStorage.getItem(e);o=o?JSON.parse(o):{},n?o[t]=JSON.stringify(n):delete o[t],sessionStorage.setItem(e,JSON.stringify(o))},get:function(e,t,n){var o=sessionStorage.getItem(e);return o&&(o=JSON.parse(o))[t]?JSON.parse(o[t]):null}},n=!0,o=function(){n=!1},r=function(){n=!0},c=function(){return!!(sessionStorage&&history&&n)},i=function(e,n){n&&d(),t.set("pageCache",e,n)},f=function(e){return t.get("pageCache",e)},a=function(e){i(e,null)},u=function(){"function"==typeof e.removeAutofocus&&m()&&e.removeAutofocus()},s=function(t,n){if("function"==typeof t&&(n=t,t=null),!c()){n&&n();return}jQuery(document).finish(),"function"==typeof e.wait&&e.finish(),setTimeout(function(){"function"==typeof e.removeAutofocus&&e.removeAutofocus();var o=jQuery(e.bodySelector);t&&(o=o.clone().find(t).replaceWith("").end());var r={body:o.html(),title:document.title,positionY:window.pageYOffset,positionX:window.pageXOffset,cachedAt:new Date().getTime()};"function"==typeof e.nextPageOffset&&(r.nextPageOffset=e.nextPageOffset()),i(document.location.href,r),jQuery(e.bodySelector).trigger("snapback-cache:cached",r),n&&n()},500)},l=function(t){if(m()){var n=f(document.location.href);jQuery(e.bodySelector).html(n.body),"function"==typeof e.removeAutofocus&&e.removeAutofocus(),setTimeout(function(){window.scrollTo(n.positionX,n.positionY)},1),a(document.location.href),jQuery(e.bodySelector).trigger("snapback-cache:loaded",n);var o=g();return o&&("function"==typeof e.refreshItems&&e.refreshItems(o),h()),!1}t&&t()},h=function(){sessionStorage.removeItem("pageCache-dirty")},g=function(){var e=sessionStorage.getItem("pageCache-dirty");if(!e)return null;var t=JSON.parse(e);return jQuery.map(t,function(e,t){return t})},p=function(e){t.set("pageCache-dirty",e,!0)},d=function(){var e=sessionStorage.getItem("pageCache");if(e){e=JSON.parse(e);var t=[];for(var n in e)t.push([n,e[n]]);if(t.length>=10){t.sort(function(e,t){return e=e[1].cachedAt,(t=t[1].cachedAt)<e?-1:t>e?1:0});for(var o=0;o<t.length+1-10;o++){var n=t[o][0];delete e[n]}sessionStorage.setItem(namespace,JSON.stringify(e))}}},m=function(){if(!c())return!1;var e=f(document.location.href);return!!(e&&e.cachedAt>new Date().getTime()-9e5)};return jQuery(document).ready(function(){u()}),jQuery(window).load(function(){l()}),{enable:r,disable:o,remove:a,loadFromCache:l,cachePage:s,markDirty:p,willUseCacheOnThisPage:m}};